import { createStore } from 'vuex'
import auth from './auth'
import global from './global'
import websocket from './websocket'

const Store = createStore({
  modules: {
    auth,
    global,
    websocket
  },
  strict: false
})

export default Store
